<template>
  <div class="wrapper">
    <div class="resetPasswordCard">
      <el-card shadow="hover">
        <div class="mooctestlogo" v-if="!showSuccess"></div>
        <div style="text-align: center" v-if="!showSuccess">
          <h2
            style="
              font-family:
                Helvetica Neue,
                Helvetica,
                Arial,
                sans-serif;
              margin-right: -2em;
            "
          >
            {{ $t("pwdReset.resetPassword") }}
            <el-button circle type="text" @click="changeLang">中/Eng</el-button>
          </h2>
        </div>
        <div v-if="!showSuccess" v-loading="resetLoading">
          <el-form
            @submit.native.prevent
            style="margin-top: 20px"
            :model="passwordForm"
            ref="passwordForm"
            label-position="right"
            label-width="100px"
            :rules="rules"
          >
            <el-form-item :label="$t('registerPage.password')" prop="password">
              <el-input
                type="password"
                :placeholder="$t('registerPage.password')"
                v-model="passwordForm.password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('registerPage.confirm')"
              prop="checkPassword"
            >
              <el-input
                type="password"
                :placeholder="$t('registerPage.inputPsdAgain')"
                v-model="passwordForm.checkPassword"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button
            :disabled="resetLoading"
            type="primary"
            style="float: right; margin-bottom: 20px; margin-right: 10px"
            @click="submitForm('passwordForm')"
          >
            {{ $t("button.confirm") }}
          </el-button>
        </div>
        <div v-if="showSuccess">
          <div
            class="el-icon-success"
            style="
              margin: 0 auto;
              display: block;
              width: 120px;
              color: #67c23a;
              font-size: 120px;
            "
          ></div>
          <p style="text-align: center">
            {{ $t("pwdReset.successInfo") }}
            <el-button circle type="text" @click="changeLang">中/Eng</el-button>
          </p>
          <p style="text-align: center">
            <el-link
              style="color: #409eff; margin-top: 10px"
              href="http://manage.mooctest.net"
            >
              {{ $t("pwdReset.manageEntrance") }}
            </el-link>
          </p>
          <p style="text-align: center">
            <el-link
              style="color: #409eff; margin-top: 10px"
              href="http://www.mooctest.net"
            >
              {{ $t("pwdReset.stuEntrance") }}
            </el-link>
          </p>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { resetPassword } from "../../api/common";
import { register } from "../../api/user";

export default {
  name: "PwdReset",
  data() {
    return {
      captcha: "",
      passwordForm: {
        password: "",
        checkPassword: "",
      },
      showSuccess: false,
      resetLoading: false,
    };
  },
  computed: {
    rules() {
      let that = this;
      let validatePass = (rule, value, callback) => {
        if (value.length > 16 || value.length < 6) {
          callback(
            new Error(that.$t("registerPage.psdLength", { s: 6, l: 16 })),
          );
        } else if (this.passwordForm.checkPass !== "") {
          this.$refs.passwordForm.validateField("checkPassword");
        }
        callback();
      };
      let validatePass2 = (rule, value, callback) => {
        if (value !== this.passwordForm.password) {
          callback(new Error(that.$t("registerPage.psdDiffer")));
        } else {
          callback();
        }
      };
      return {
        password: [
          { required: true, message: that.$t("common.notNull") },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: that.$t("common.notNull") },
          { validator: validatePass2, trigger: "blur" },
        ],
      };
    },
  },
  mounted() {
    this.captcha = this.$route.params.captcha;
    localStorage.clear();
    // localStorage.clear();
    this.reset();
  },
  methods: {
    submitForm() {
      let that = this;
      this.$refs["passwordForm"]
        .validate()
        .then((valid) => {
          if (valid) {
            //表单验证成功后，开始登录
            this.resetLoading = true;
            resetPassword(this.captcha, this.passwordForm.password)
              .then((res) => {
                this.resetLoading = false;
                this.showSuccess = true;
              })
              .catch((error) => {
                this.resetLoading = false;
                this.$notify({
                  type: "error",
                  title: that.$t("common.fail"),
                  duration: 3000,
                });
              });
          }
        })
        .catch((err) => {
          this.$notify({
            type: "warning",
            title: that.$t("common.error"),
            duration: 3000,
            message: that.$t("common.formatInfo"),
          });
        }); //valid
    },

    changeLang() {
      if (this.$i18n.locale === "cn") {
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "cn";
        localStorage.setItem("lang", "cn");
      }
    },
  },
};
</script>
<style scoped>
.wrapper {
  /* position: absolute; */
  /* background-color: red; */
  background: url("../../assets/img/loginBg.jpeg");
  /* height: 100vh;
  width: 100vh; */

  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #fff;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  min-height: 700px;
  /*overflow: auto;*/
  overflow: visible;
  position: relative;
}

.mooctestlogo {
  background-image: url("../../assets/img/mooctestlogo.png");
  background-size: cover;
  width: 91px;
  height: 100px;
  margin: 0 auto;
}

.resetPasswordCard {
  height: 400px;
  width: 500px;
  /* background-color: aqua; */
  margin: 100px auto;
}
</style>
